import { Roles } from '@/utils/roles';
import { useAuthContext } from './useAuthContext';

export const useRole = (roles: number[] = []) => {
  const { user } = useAuthContext();
  const newRoles = [...roles];
  newRoles.push(Roles.SUPER_ADMIN, Roles.OWNER_SOFT);
  let authorized = false;
  if (newRoles.includes(user?.role?.id ?? 0)) {
    authorized = true;
  }
  return {
    authorized,
  };
};
